// side-nav — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: flex;
    flex-direction: column;
    width: var(--run-side-nav-width, 16rem);
    background: var(--run-wf-surface, transparent);
    border-right: 1px dashed var(--run-wf-border, #94a3b8);
    box-shadow: none;
    padding-block: var(--run-side-nav-padding-block, var(--run-space-semantic-sm, 1rem));
    padding-inline: var(--run-side-nav-padding-inline, var(--run-space-semantic-sm, 1rem));
    box-sizing: border-box;
    overflow-y: auto;
    font-family: var(--run-wf-font-family, var(--run-font-semantic-family-body));
    transition: width 0.2s ease, opacity 0.2s ease;
  }

  :host([collapsed]) {
    width: var(--run-side-nav-collapsed-width, 3.5rem);
    overflow: hidden;
  }

  :host([disabled]) {
    opacity: 0.5;
    pointer-events: none;
  }

  [part="base"] {
    display: flex;
    flex-direction: column;
    gap: var(--run-side-nav-gap, var(--run-space-semantic-xs));
    flex: 1;
  }

  :host([collapsed]) [part="base"] {
    overflow: hidden;
  }

  [part="section-label"] {
    display: block;
    padding-block: var(--run-side-nav-section-header-padding-block, var(--run-space-semantic-xs, 0.5rem));
    padding-inline: var(--run-side-nav-section-header-padding-inline, var(--run-space-semantic-xs, 0.75rem));
  }

  [part="section-label-text"] {
    color: var(--run-wf-text-subtle, #94a3b8);
    font-size: var(--run-side-nav-section-header-font-size, var(--run-font-size-xs, 11px));
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-family: var(--run-wf-font-family, 'Architects Daughter', cursive);
  }

  :host([collapsed]) [part="section-label"] {
    display: none;
  }

  [part="content"] {
    display: contents;
  }
`;

export function render(host) {
  const label = host.label && host.label !== 'Site navigation' ? host.label : '';

  const sectionLabelHtml = label
    ? `<span part="section-label" aria-hidden="true">
        <span part="section-label-text">${label}</span>
      </span>`
    : '';

  host.shadowRoot.innerHTML = `
    <nav part="base" aria-label="${host.label || ''}">
      ${sectionLabelHtml}
      <slot part="content"></slot>
    </nav>
  `;
}
